import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { TaxesResponseModel, AllTaxesResponseModel, TaxesDto, TaxDropDownDto, TaxDropDownResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TrimsItemRequest, TrimsRequset } from './dto/trims-req';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { TrimsMappingService } from './trims-configuration.service';
import { TrimsConfigurationDto } from './dto/trims-configuration-dto';

@ApiTags('trims-mapping')
@Controller('trims-mapping')
export class TrimsMappingController {
    constructor(
        private trimsMappingService: TrimsMappingService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }
    @Post('/getTrimsData')
    async getTrimsData(@Body() trimsReq: TrimsRequset): Promise<CommonResponse> {
        try {
            return await this.trimsMappingService.getTrimsData(trimsReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }
    @Post('/getalltrimsmappingdetails')
    async getalltrimsmappingdetails(): Promise<CommonResponse> {
        try {
            return await this.trimsMappingService.getalltrimsmappingdetails();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getalltrimsitemmappingdetailsByTrimsId')
    async getalltrimsitemmappingdetailsByTrimsId(@Body() req: TrimsItemRequest): Promise<CommonResponse> {
        try {
            return await this.trimsMappingService.getalltrimsitemmappingdetailsByTrimsId(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/saveTrimsConfiguration')
    async saveTrimsConfiguration(@Body() trimsReq: TrimsConfigurationDto): Promise<CommonResponse> {
        try {
            return await this.trimsMappingService.saveTrimsConfiguration(trimsReq);
        } catch (error) {
            console.log(error)
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getAllTrimsDataForTrimId')
    async getAllTrimsDataForTrimId(@Body() trimsReq: TrimsItemRequest): Promise<CommonResponse> {
        try {
            return await this.trimsMappingService.getAllTrimsDataForTrimId(trimsReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }
}
